module.exports = __webpack_public_path__ + "startpage-746fed5a/template-3-preview-35b271184ae9d780dad90c1b6a1e661d.jpg";